import React from 'react';
import styles from './index.module.scss';

const AddressDetails = ({ addressObj }) => {
  
  return(
    <div className={styles['address-container']}>
      <span className={styles['title']}>Storage section: <span className={styles['value']}>{addressObj.storageSection}</span></span>
      <span className={styles['title']}>Furniture No: <span className={styles['value']}>{addressObj.furnitureNo}</span></span>
      <span className={styles['title']}>Shelf No: <span className={styles['value']}>{addressObj.shelfNo}</span></span>
    </div>
  );
};

export default AddressDetails;